import { useAuthContext } from '@/features/auth/context'
import useUser from '@/features/auth/hooks/useUser'
import useTranslation from '@/hooks/useTranslation'
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import { Stack } from '@mui/system'
import { lowerCase, snakeCase } from 'lodash'
import React, { FC } from 'react'
import { useLocation } from 'react-router-dom'
import TurfQualityTableRow from './TurfQualityTableRow'
import classes from './style.module.scss'
import { ITurfQuality } from '@/api/config/turfQualityApi'

interface TurfQualityTableProps {
  rows: ITurfQuality[]
  onDelete: (id: number | string, interfaceId: string | number) => void
}

interface ITableHeaderProps {
  [key: string]: {
    label: string
    style?: object
    showUnitLabel?: boolean
  }
}

const TurfQualityTable: FC<TurfQualityTableProps> = ({
  rows,
  onDelete,
}) => {
  const { t } = useTranslation()
  const { interfaceId } = useAuthContext()
  const { data: user } = useUser()

  const turfQualityTableHeaders: ITableHeaderProps = {
    order: {
      label: '#',
      style: {
        width: '5%',
        borderRight: '1px solid #d7d7d7',
      },
    },
    turfQualityName: {
      label: t('turfQualityName'),
      style: {
        width: '20%',
        borderRight: '1px solid #d7d7d7',
      },
    },
    irrigationFactor: {
      label: t('irrigationFactor'),
      style: {
        width: '20%',
        borderRight: '1px solid #d7d7d7',
      },
    },
    calculatedWaterBudget: {
      label: t('calculatedWaterBudget'),
      style: {
        width: '15%',
        borderRight: '1px solid #d7d7d7',
      },
    },
    action: {
      label: t('commonTableHeaderAction'),
      style: {
        width: 'calc(100% - 90%)',
      },
    },
  }

  return (
    <Stack flexGrow="1">
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {Object.entries(turfQualityTableHeaders).map(
                ([key, turfQuality]) => {
                  const headerContent = turfQuality.label
                  return (
                    <TableCell
                      key={key + snakeCase(lowerCase(turfQuality.label))}
                      sx={turfQuality.style}
                    >
                      {key === 'calculatedWaterBudget' ? (
                        <Tooltip
                          title={
                            <span style={{ fontSize: '0.9rem' }}>
                              {t('turfQualityCalculatedWaterBudgetNote')}
                            </span>
                          }
                          arrow
                          placement="top"
                        >
                          <div>
                            {headerContent}  
                            <IconButton size="small">
                              <InfoOutlinedIcon fontSize="small" />
                            </IconButton>
                          </div>
                        </Tooltip>
                      ) : (
                        headerContent
                      )}
                      
                    </TableCell>
                  )
                },
              )}
            </TableRow>
          </TableHead>

          <TableBody className={classes.tableBody}>
            {rows?.map((row) => (
              <TurfQualityTableRow
                key={row.id}
                row={row}
                handleDeleteItem={onDelete}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default TurfQualityTable
